import { render, staticRenderFns } from "./JobApplicantPrivacyPolicy.vue?vue&type=template&id=0db956f0"
import script from "./JobApplicantPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./JobApplicantPrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./JobApplicantPrivacyPolicy.vue?vue&type=style&index=0&id=0db956f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports